import { render, staticRenderFns } from "./IconMagic.vue?vue&type=template&id=4398d583"
import script from "./IconMagic.vue?vue&type=script&lang=js"
export * from "./IconMagic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports